<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span><i class="fal fa-search"></i> {{ 'CLIENT_FINDER.CLIENT_FINDER' | translate }} </span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="client-finder-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row align-items-end">
      <div class="col-sm-6">
        <div>
          <label>{{ 'CLIENT_FINDER.KEYWORDS' | translate }}</label>
          <input type="text" class="form-control" formControlName="keywords" />
        </div>
      </div>

      <div class="col-sm-1">
        <div class="custom-control custom-checkbox checkbox-margin me-3">
          <input type="checkbox" class="custom-control-input" formControlName="exact" id="client-finder-exact" />
          <label class="custom-control-label" for="client-finder-exact">
            {{ 'CLIENT_FINDER.EXACT' | translate }}
          </label>
        </div>
      </div>

      <!--      <div class="col-sm-4">-->
      <!--        <div class="form-group">-->
      <!--          <label>{{ 'CLIENT_FINDER.COMPANY' | translate }}</label>-->
      <!--          <input type="text" class="form-control" formControlName="company_name" />-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="col-sm-4">-->
      <!--        <div class="form-group">-->
      <!--          <label>{{ 'CLIENT_FINDER.PHONE' | translate }}</label>-->
      <!--          <input type="text" class="form-control" formControlName="phone" />-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="col-sm-4">-->
      <!--        <div class="form-group">-->
      <!--          <label>{{ 'CLIENT_FINDER.EMAIL' | translate }}</label>-->
      <!--          <input type="text" class="form-control" formControlName="email" />-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="col-sm-2">
        <button type="button" class="btn btn-primary btn-input" (click)="loadData()">
          {{ 'CLIENT_FINDER.FIND' | translate }}
        </button>
      </div>

      <div class="col-sm-3 text-end">
        <button type="button" class="btn btn-info btn-input" (click)="addNewClient()">
          {{ 'CLIENT_FINDER.ADD_NEW_CLIENT' | translate }}
        </button>
      </div>

      <div class="col-sm-12">
        <div class="modal-section-title mt-2">
          {{ 'CLIENT_FINDER.CLIENTS_FOUND' | translate }}
        </div>

        <kendo-grid
          [data]="gridData"
          [pageSize]="clientsResponse?.meta.per_page"
          [sortable]="false"
          [filterable]="false"
          [columnMenu]="true"
          [filter]="state?.filter"
          [skip]="state?.skip"
          [pageable]="true"
          (dataStateChange)="loadData($event)"
        >
          <kendo-grid-column [width]="50" class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <input
                type="checkbox"
                [checked]="isClientSelected(dataItem.id)"
                (change)="clientCheckboxChange(dataItem)"
                [disabled]="!multiple && selectedClients.length >= 1 && !isClientSelected(dataItem.id)"
              />
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="id" title="{{ 'CLIENT_FINDER.ID' | translate }}" [width]="50"></kendo-grid-column>

          <kendo-grid-column field="name" title="{{ 'CLIENT_FINDER.NAME' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <app-client-box [client]="dataItem"></app-client-box>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="country.name" title="{{ 'CLIENT_FINDER.COUNTRY' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <app-country-box [country]="dataItem.country"></app-country-box>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="city.name" title="{{ 'CLIENT_FINDER.CITY' | translate }}"> </kendo-grid-column>

          <kendo-grid-column
            field="vat_number"
            title="{{ 'CLIENT_FINDER.VAT_NUMBER' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column [width]="120" title="{{ 'CLIENT_FINDER.ACTIONS' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <button *ngIf="!multiple" (click)="selectClient(dataItem)" type="button" class="btn btn-xs btn-info">
                {{ 'CLIENT_FINDER.SELECT' | translate }}
              </button>
              <app-edit-button (click)="edit(dataItem)"></app-edit-button>
            </ng-template>
          </kendo-grid-column>

          <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-input></kendo-pager-input>
            <kendo-pager-info></kendo-pager-info>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
            <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
          </ng-template>
        </kendo-grid>
      </div>

      <div class="col-sm-12">
        <div class="modal-section-title mt-2">
          {{ 'CLIENT_FINDER.SELECTED_CLIENTS' | translate }}
        </div>

        <div *ngIf="!selectedClients.length">
          {{ 'CLIENT_FINDER.NO_CLIENTS_SELECTED' | translate }}
        </div>

        <kendo-grid [data]="selectedClients" *ngIf="selectedClients.length">
          <kendo-grid-column field="id" title="{{ 'CLIENT_FINDER.ID' | translate }}" [width]="50"></kendo-grid-column>

          <kendo-grid-column field="name" title="{{ 'CLIENT_FINDER.NAME' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <app-client-box [client]="dataItem"></app-client-box>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="country.name" title="{{ 'CLIENT_FINDER.COUNTRY' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <app-country-box [country]="dataItem.country"></app-country-box>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="city.name" title="{{ 'CLIENT_FINDER.CITY' | translate }}"> </kendo-grid-column>

          <kendo-grid-column
            field="vat_number"
            title="{{ 'CLIENT_FINDER.VAT_NUMBER' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column [width]="50">
            <ng-template kendoGridHeaderTemplate *ngIf="multiple">
              <button
                (click)="deselectAll()"
                type="button"
                class="btn btn-danger btn-ico"
                [ngbTooltip]="'CLIENT_FINDER.REMOVE_ALL' | translate"
                container="body"
              >
                <i class="fal fa-trash"></i>
              </button>
            </ng-template>

            <ng-template kendoGridCellTemplate let-dataItem>
              <button
                (click)="clientCheckboxChange(dataItem)"
                type="button"
                class="btn btn-danger btn-ico"
                [ngbTooltip]="'CLIENT_FINDER.REMOVE' | translate"
                container="body"
              >
                <i class="fal fa-trash"></i>
              </button>
            </ng-template>
          </kendo-grid-column>

          <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-input></kendo-pager-input>
            <kendo-pager-info></kendo-pager-info>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
          </ng-template>
        </kendo-grid>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button
    type="submit"
    class="btn btn-outline-dark btn-xs"
    form="client-finder-form"
    [disabled]="(!multiple && selectedClients.length !== 1) || (multiple && selectedClients.length <= 0)"
  >
    <span *ngIf="selectedClients.length > 0">({{ selectedClients.length }})</span>
    {{ 'CLIENT_FINDER.SELECT' | translate }}
  </button>
</div>
